import { Button } from '../../../Utility/Button';
import AdminViewHeader from '../../../Utility/AdminViewHeader';
import AdminViewContent from '../../../Utility/AdminViewContent';
import { VoiceModel } from '../../../../Types';
import { PencilSimpleIcon, TrashIcon, CopyIcon } from '@phosphor-icons/react';
import { RootState, useAppSelector } from '../../../../store';
import { UserSettings } from '../../../../Types';
import useVoiceModels from '../../../../Hooks/useVoiceModels';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { voiceModelService } from '../../../../Services/voiceModelService';
import PaginatedView from '../../../Utility/PaginatedView';

function VoiceModels() {
    const settings = useAppSelector((state: RootState) => state.settings);
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const { ModelsActions, handleCopyModel, handleNavigate, i18n, windowWidth, getBreakpoint } = useVoiceModels();
    const GRID_COLS = 'grid-cols-[1fr_auto]'; 

    return (
        <>
            <PaginatedView
                listType={PaginationListType.VoiceModels}
                itemsFunction={voiceModelService.getModelsByPage}
                itemsPerPage={10}
                renderItem={(model: VoiceModel, index: number) => (
                    <AdminViewContent
                        key={model.identifier}
                        mobile={windowWidth < getBreakpoint('md')}
                        identifier={model.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [{ content: model.title, image: model.image, showImage: true }],
                            button: {
                                buttons: [
                                    {
                                        variant: 'primaryRound',
                                        onClick: () => handleNavigate(`/admin/voicemodels/${model.identifier}`),
                                        icon: <PencilSimpleIcon />,
                                    },
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'secondaryRound'
                                                : 'disabledRound',
                                        onClick: () => handleCopyModel(model),
                                        icon: <CopyIcon />,
                                    },
                                    {
                                        variant:
                                            model.identifier === settings.ttsModel ||
                                            model.identifier === settings.transcribeModel
                                                ? 'disabledRound'
                                                : 'secondaryRound',
                                        onClick: () =>
                                            model.identifier === settings.ttsModel ||
                                            model.identifier === settings.transcribeModel
                                                ? null
                                                : ModelsActions.handleOpenConfirmDialog(model.identifier),
                                        icon: <TrashIcon />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
            >
                {({ list, filter }) => (
                    <>
                        {filter}
                        <div className="mb-4 md:hidden">
                            {(!settings.demo || userSettings.isSuperAdmin) && (
                                <Button
                                    className="w-full mb-2"
                                    onClick={() => handleNavigate('/admin/voicemodels/new')}
                                >
                                    {i18n.translate({ id: 'button', sourceName: 'VoiceModels' })}
                                </Button>
                            )}
                        </div>
                        <div className="hidden md:block">
                            <AdminViewHeader
                                gridCols={GRID_COLS}
                                cols={{
                                    cols: [
                                        {
                                            text: i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' }),
                                        },
                                    ],
                                    button:
                                        !settings.demo || userSettings.isSuperAdmin
                                            ? {
                                                  text: i18n.translate({ id: 'button', sourceName: 'VoiceModels' }),
                                                  function: () => handleNavigate('/admin/voicemodels/new'),
                                              }
                                            : undefined,
                                }}
                            />

                            <hr className="border-layout-borderColor mt-5" />
                        </div>
                        {list}
                    </>
                )}
            </PaginatedView>
        </>
    );
}

export default VoiceModels;
